import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getService"]),
    profile() {
      return this.$OAuth.data.profile;
    },
    aclArray() {
      if(this.profile && this.profile.acl){
        return Array.isArray(this.profile.acl) ? this.profile.acl : [this.profile.acl];
      }
      return [];
    },
    isLoggedIn() {
      return this.profile ? true : false;
    },
    serviceData() {
      return this.getService;
    },
    hasDirectorRights() {
      // this caters for new directors who dont have a service registered under their name yet because they were educators before
      // such users could have TTSDS Educator role/s specific to service/s
      // But also a generic TTSDS Director role for SE-0000000
      if (this.profile) {
        return this.aclArray.some(role => role.match(/TTSDS Director/));
      } else {
        return false;
      }
    },
    isVerifiedDirector() {
      // return this.profile && this.profile.roles === "NONGOV.CENTREDIRECTOR" ? true : false;
      if (this.profile) {
        const validRoles = ["NONGOV.CENTREDIRECTOR", "SCHOOL.PRINCIPAL"];
        var rolesArray = [];
        if(Array.isArray(this.profile.roles)) {
          rolesArray = [...this.profile.roles];
        } else {
          rolesArray.push(this.profile.roles);
        }
        const filteredRole = validRoles.filter(value => rolesArray.includes(value));
        if(filteredRole.length) {
          return true;
        }
      } else {
        return false;
      }
    },
    isSchoolPrincipal() {
      if (this.profile) {
        const validRoles = ["SCHOOL.PRINCIPAL"];
        var rolesArray = [];
        if(Array.isArray(this.profile.roles)) {
          rolesArray = [...this.profile.roles];
        } else {
          rolesArray.push(this.profile.roles);
        }
        const filteredRole = validRoles.filter(value => rolesArray.includes(value));
        if(filteredRole.length) {
          return true;
        }
      } else {
        return false;
      }
    },
    isCentreDirector() {
      if (this.profile) {
        return this.aclArray.includes(`${this.serviceData.seNumber} TTSDS Director`);
      } else {
        return false;
      }
    },
    isCentreEducator() {
      if (this.profile) {
        return this.profile.acl.includes(`${this.serviceData.seNumber} TTSDS Educator`);
      } else {
        return false;
      }
    },
    getServiceRole() {
      if (this.profile) {
         if (this.aclArray.includes(`${this.serviceData.seNumber} TTSDS Director`)) {
          return "Director";
        } else {
          return "Educator";
        }
      } else {
        return false;
      }
    },
    isServiceDashboardDirector() {
      if(this.row) {
        return this.aclArray.includes(`${this.row.seNumber.value} TTSDS Director`);
      } else {
        return false;
      }
    }
  }
};
